module.exports = __webpack_public_path__ + "static/media/adjust.8ef29616.svg";